export function isInIframe() {
    try {
        return window.self !== window.top; // true => inside a frame
    } catch {
        // Defensive: if any cross-origin access throws (e.g., very old/odd contexts), assume framed
        return true;
    }
}